export class GetSearchTree {
  static readonly type = '[AdvancedSearchTree] Get Search Tree'
}

export class SetSearchTreeArray {
  static readonly type = '[AdvancedSearchTree] Set search tree array'
  constructor(public searchTreeArr: string[]) {}
}
